<template>
  <div class="email-verification">
    <h3>Verify email address</h3>
    <p>
      We have sent a confirmation email to {{ email }}. Please enter the
      verification code to finish creating your account.
    </p>
    <code-input
      v-model="code"
      @code="submit"
      :readonly="submitting"
    ></code-input>
    <p>
      If you haven't received the verification email after a couple of minutes,
      please check your junk/spam folder or
      <a href="" @click.prevent="resend">resend the verification email</a>.
    </p>
  </div>
</template>

<script>
import axios from "axios";
import CodeInput from "./CodeInput";

export default {
  components: { CodeInput },
  data() {
    return {
      code: "",
      submitting: false,
    };
  },
  props: {
    id: { type: Number, required: true },
    email: { type: String, required: true },
  },
  methods: {
    async submit() {
      this.submitting = true;
      let response;
      try {
        response = await axios.post("/api/signin/verify_email", {
          id: this.id,
          code: this.code,
          email: this.email,
        });
      } catch (error) {
        await swal(
          "Verify email address",
          error.response.data.error.description,
          "error"
        );
        this.code = "";
        this.submitting = false;
        return;
      }
      this.$emit("verified");
    },
    async resend() {
      this.submitting = true;
      let response;
      try {
        response = await axios.post("/api/signin/verify_email/resend", {
          id: this.id,
          email: this.email,
        });
      } catch (error) {
        await swal(
          "Verify email address",
          error.response.data.error.description,
          "error"
        );
        this.submitting = false;
        return;
      }
      this.submitting = false;
      swal(
        "Verify email address",
        "Verification email has been sent. Please check your inbox and enter the code to proceed.",
        "success"
      );
    },
  },
};
</script>
